import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CONSTANTS } from 'common/constants';
import { requestAddress } from 'store/api/application.api';

const initialState = {
    postalStatus: CONSTANTS.FULFILLED,
    postalList: []
} as any;

export const getPostalData = createAsyncThunk('application/postal', async (postalCode: string, { getState }) => {
    const response = await requestAddress(postalCode);
    if (Array.isArray(response) && response.length > 0) {
        return {
            isValid: true,
            postalData: response.map((data: any) => ({
                blockNo: data.BlockNumber || '',
                streetName: data.StreetName || '',
                buildingName: data.BuildingName || '',
                postalCode
            }))
        };
    }
    return { isValid: false };
});
export const postalSlice = createSlice({
    name: 'postal',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPostalData.pending, (state) => {
                state.postalStatus = CONSTANTS.LOADING;
            })
            .addCase(getPostalData.fulfilled, (state, action) => {
                const { isValid, postalData } = action.payload;
                state.postalStatus = CONSTANTS.FULFILLED;
                if (isValid && postalData && postalData.length > 0) {
                    // Remove any existing data for this postal code first
                    const postalCode = postalData[0].postalCode;
                    const filteredList = state.postalList.filter((item: any) => item.postalCode !== postalCode);
                    // Then add the new data for this postal code
                    state.postalList = [...filteredList, ...postalData];
                }
            });
    }
});

export const {} = postalSlice.actions;

export default postalSlice.reducer;
